/* PhoneMatter Aura quick add: the + on a product card.
   One variant: adds straight away. Several: a small sheet with the options (your saved iPhone preselected), then Add to cart. */
(function () {
  'use strict';
  var KEY = 'user_selected_device_model';
  var scrim, sheet, toast, toastT, cur = null, sel = {}, moreOpen = {};

  function $(s, c) { return (c || document).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(c) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currencyDisplay: 'narrowSymbol', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function saved() { try { return (localStorage.getItem(KEY) || '').trim().toLowerCase(); } catch (e) { return ''; } }

  function build() {
    if (sheet) return;
    scrim = document.createElement('div'); scrim.className = 'pmq-scrim';
    sheet = document.createElement('div'); sheet.className = 'pmq'; sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    toast = document.createElement('div'); toast.className = 'pmq-toast'; toast.setAttribute('role', 'status');
    document.body.appendChild(scrim); document.body.appendChild(sheet); document.body.appendChild(toast);
    scrim.addEventListener('click', close);
    sheet.addEventListener('click', onSheet);
    sheet.addEventListener('change', function (e) {
      var el = e.target.closest && e.target.closest('.pmq-sel');
      if (!el) return;
      var n = el.getAttribute('data-n');
      sel[n] = el.value;
      if (!variantFor(cur)) {
        var names = cur.options.map(function (o) { return o.name || o; });
        var idx = names.indexOf(n);
        var alt = cur.variants.filter(function (v) { return v['option' + (idx + 1)] === el.value; })[0];
        if (alt) names.forEach(function (nn, i) { sel[nn] = alt['option' + (i + 1)]; });
      }
      render();
    });
  }
  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open'); scrim.classList.remove('on');
    document.body.classList.remove('pmq-lock');
  }
  function say(html) {
    toast.innerHTML = html; toast.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('on'); }, 3200);
  }

  function variantFor(p) {
    var names = p.options.map(function (o) { return o.name || o; });
    return p.variants.filter(function (v) {
      return names.every(function (n, i) { return sel[n] === v['option' + (i + 1)]; });
    })[0] || null;
  }
  function thumb(src, w) {
    return src ? String(src).replace(/(\.\w+)(\?|$)/, '_' + w + 'x' + w + '$1$2') : '';
  }
  function imgFor(p, i, val) {
    var v = p.variants.filter(function (x) { return x['option' + (i + 1)] === val && x.featured_image && x.featured_image.src; })[0];
    return v ? v.featured_image.src : '';
  }
  function render() {
    var p = cur;
    var names = p.options.map(function (o) { return o.name || o; });
    var v = variantFor(p);
    var vImg = v && v.featured_image && v.featured_image.src ? v.featured_image.src : (p.featured_image || '');
    var html = '<div class="pmq-grab"></div><button type="button" class="pmq-x" data-q="close" aria-label="Close">&times;</button>' +
      '<div class="pmq-head">' + (vImg ? '<img src="' + esc(thumb(vImg, 200)) + '" alt="">' : '') +
      '<div><b>' + esc(p.title) + '</b><span>' + (v ? money(v.price) : '') + '</span></div></div><div class="pmq-opts">';
    names.forEach(function (n, i) {
      var vals = (p.options[i].values || []);
      if (!vals.length) { var seen = {}; vals = p.variants.map(function (x) { return x['option' + (i + 1)]; }).filter(function (x) { if (seen[x]) return false; seen[x] = 1; return true; }); }
      /* the phone model stays as pills; colour, design and style show the photo, like the product page */
      var isModel = /model|device|phone|compat/i.test(n);
      var photos = !isModel && vals.length > 1 && vals.some(function (val) { return imgFor(p, i, val); });
      if (isModel && vals.length > 2) {
        /* more than two phones: a dropdown instead of a wall of pills */
        html += '<div class="pmq-g"><div class="pmq-gt">' + esc(n) + '</div><label class="pmq-selwrap"><select class="pmq-sel" data-n="' + esc(n) + '" aria-label="' + esc(n) + '">';
        vals.forEach(function (val) {
          var test = {}; Object.keys(sel).forEach(function (k) { test[k] = sel[k]; }); test[n] = val;
          var ok = p.variants.some(function (x) { return names.every(function (nn, ii) { return test[nn] === x['option' + (ii + 1)]; }) && x.available; });
          html += '<option value="' + esc(val) + '"' + (sel[n] === val ? ' selected' : '') + '>' + esc(val) + (ok ? '' : ' (sold out)') + '</option>';
        });
        html += '</select></label></div>';
        return;
      }
      html += '<div class="pmq-g"><div class="pmq-gt' + (photos ? ' pmq-gt--au' : '') + '">' + esc(n) + (photos ? ': <b>' + esc(sel[n]) + '</b>' : '') + '</div><div class="' + (photos ? 'pmq-sws' + (moreOpen[n] ? ' is-open' : '') : 'pmq-pills') + '">';
      vals.forEach(function (val, k) {
        var test = {}; Object.keys(sel).forEach(function (k) { test[k] = sel[k]; }); test[n] = val;
        var ok = p.variants.some(function (x) { return names.every(function (nn, ii) { return test[nn] === x['option' + (ii + 1)]; }) && x.available; });
        if (photos) {
          var src = imgFor(p, i, val) || (p.featured_image || '');
          html += '<button type="button" class="pmq-sw' + (sel[n] === val ? ' on' : '') + (ok ? '' : ' off') + (k > 4 ? ' is-x' : '') + '" data-n="' + esc(n) + '" data-v="' + esc(val) + '" aria-label="' + esc(val) + '" aria-pressed="' + (sel[n] === val) + '"><img src="' + esc(thumb(src, 120)) + '" alt="" width="56" height="56" loading="lazy"></button>';
        } else {
          html += '<button type="button" class="pmq-pill' + (sel[n] === val ? ' on' : '') + (ok ? '' : ' off') + '" data-n="' + esc(n) + '" data-v="' + esc(val) + '">' + esc(val) + '</button>';
        }
      });
      if (photos && vals.length > 5) html += '<button type="button" class="pmq-more" data-q="more" data-n="' + esc(n) + '">' + (moreOpen[n] ? 'Less' : '+' + (vals.length - 5)) + '</button>';
      html += '</div></div>';
    });
    html += '</div><button type="button" class="pmq-add" data-q="add"' + (v && v.available ? '' : ' disabled') + '>' + (v && v.available ? 'Add to cart · ' + money(v.price) : 'Sold out') + '</button>';
    sheet.innerHTML = html;
  }
  function open(p) {
    build();
    cur = p; sel = {};
    var s = saved();
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    p.options.forEach(function (o, i) {
      var n = o.name || o;
      sel[n] = first['option' + (i + 1)];
      if (s && /model|device|phone|compat/i.test(n)) {
        var vals = (o.values && o.values.length) ? o.values : p.variants.map(function (x) { return x['option' + (i + 1)]; });
        /* match the saved phone exactly; the loose fallback never lets "iPhone 18 Pro" land on "iPhone 18 Pro Max" (or Plus, Mini, Ultra, Air) */
        var nz = function (x) { return String(x).replace(/[\s ]+/g, ' ').trim().toLowerCase(); }, sn = nz(s);
        var m = vals.filter(function (x) { return nz(x) === sn; })[0] || vals.filter(function (x) { var t = nz(x), k = t.indexOf(sn); return k > -1 && !/^\s*(pro|max|plus|mini|ultra|air|e)\b/.test(t.slice(k + sn.length)); })[0];
        if (m) sel[n] = m;
      }
    });
    /* fall back to the first variant that exists if the combination does not */
    if (!variantFor(p)) p.options.forEach(function (o, i) { sel[o.name || o] = first['option' + (i + 1)]; });
    /* the remembered phone is kept, but the pick moves to a colour that is in stock for that phone; if that phone is sold out in every colour, the first in-stock variant is used */
    var pv = variantFor(p);
    if (pv && !pv.available) {
      var names0 = p.options.map(function (o) { return o.name || o; });
      var modelAt = names0.map(function (n) { return /model|device|phone|compat/i.test(n); }).indexOf(true);
      var same = p.variants.filter(function (x) { return x.available && (modelAt < 0 || x['option' + (modelAt + 1)] === sel[names0[modelAt]]); })[0] || first;
      names0.forEach(function (n, i) { sel[n] = same['option' + (i + 1)]; });
    }
    render();
    scrim.classList.add('on'); sheet.classList.add('is-open'); document.body.classList.add('pmq-lock');
  }

  function bumpCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      [].forEach.call(document.querySelectorAll('#CartCount, .site-header__cart-count, .cart-count-bubble'), function (n) { n.textContent = c.item_count; n.classList.remove('hide'); });
      [].forEach.call(document.querySelectorAll('.header-cart'), function (e) { e.classList.remove('pm-bump'); void e.offsetWidth; e.classList.add('pm-bump'); });
    }).catch(function () { return 0; });
  }
  function holdBusy(t0, ms, fn) { var w = ms - (Date.now() - t0); if (w > 0) setTimeout(fn, w); else fn(); }
  function addVariant(id, btn, after) {
    var t0 = Date.now();
    if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (j) { return new Promise(function (res) { holdBusy(t0, 750, function () { res(j); }); }); })
      .then(function (j) {
        try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) { e = 0; }
        if (btn) { btn.classList.remove('is-busy'); btn.classList.add('is-ok'); setTimeout(function () { btn.classList.remove('is-ok'); btn.disabled = false; }, 1400); }
        build();
        /* open the theme's own cart drawer with the fresh cart; fall back to the small toast if it is not on this page */
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && j && j.sections && j.sections['cart-drawer']) {
          setTimeout(function () { try { drawer.renderContents(j); } catch (err) { say('Added to cart <a href="/cart">View cart</a>'); } }, 420);
        } else { say('Added to cart <a href="/cart">View cart</a>'); }
        bumpCount();
        if (after) setTimeout(after, 300);
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; }
        build();
        var fail = function (m) { say(m || 'Could not add this one. Try again.'); };
        if (err && typeof err.json === 'function') err.json().then(function (j) { fail(j && j.description && /sold out|stock|cart|available/i.test(j.description) ? esc(j.description) : ''); }, function () { fail(''); });
        else fail('');
      });
  }

  function onSheet(e) {
    var t = e.target.closest('[data-q], .pmq-pill, .pmq-sw');
    if (!t) return;
    if (t.getAttribute('data-q') === 'close') { close(); return; }
    if (t.getAttribute('data-q') === 'more') { moreOpen[t.getAttribute('data-n')] = !moreOpen[t.getAttribute('data-n')]; render(); return; }
    if (t.classList.contains('pmq-pill') || t.classList.contains('pmq-sw')) {
      sel[t.getAttribute('data-n')] = t.getAttribute('data-v');
      /* if the new combination is not a real variant, move the other options to one that is */
      if (!variantFor(cur)) {
        var names = cur.options.map(function (o) { return o.name || o; });
        var idx = names.indexOf(t.getAttribute('data-n'));
        var alt = cur.variants.filter(function (v) { return v['option' + (idx + 1)] === t.getAttribute('data-v'); })[0];
        if (alt) names.forEach(function (n, i) { sel[n] = alt['option' + (i + 1)]; });
      }
      render();
      return;
    }
    if (t.getAttribute('data-q') === 'add') {
      var v = variantFor(cur);
      if (v && v.available) addVariant(v.id, t, close);
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pmc-add');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-busy')) return;
    var single = b.getAttribute('data-single') === 'true';
    if (single && b.getAttribute('data-id')) { build(); addVariant(parseInt(b.getAttribute('data-id'), 10), b); return; }
    b.classList.add('is-busy');
    var tc = Date.now();
    fetch('/products/' + b.getAttribute('data-handle') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
      if (p.variants.length === 1) { b.classList.remove('is-busy'); if (!p.variants[0].available) { say('Sold out. Check back soon.'); return; } addVariant(p.variants[0].id, b); return; }
      holdBusy(tc, 600, function () { b.classList.remove('is-busy'); open(p); });
    }).catch(function () { b.classList.remove('is-busy'); window.location.href = '/products/' + b.getAttribute('data-handle'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
